import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { selectedLicenseTypeSelector } from '../../License/store/selectors';

import { nationalCurrencySelector } from '../../../store/configs/selectors';
import { versionComparisonSelector } from '../../../store/audit/selectors';
import getItemFields from '../helpers/getItemFields';

function useItemFields() {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const {
    lpcoResponse: { invoiceCurrencyCode },
  } = useSelector(versionComparisonSelector);
  const nationalCurrency = useSelector(nationalCurrencySelector);
  const licenseTypeData = useSelector(selectedLicenseTypeSelector).data?.licenseTypeResponse;

  return useMemo(
    () =>
      licenseTypeData
        ? getItemFields({ licenseType: licenseTypeData, t, invoiceCurrencyCode, nationalCurrency, locale: language })
        : [],
    [invoiceCurrencyCode, language, licenseTypeData, nationalCurrency, t]
  );
}

export default useItemFields;
